import { IFile } from './IFile';
import { Observable } from 'rxjs';
import { promise } from 'protractor';
export abstract class FilesServiceInterface {
    abstract uploadFiles(files: any, folder: string): Observable<any>;
    abstract getFile(id: number): Observable<Blob>;
    abstract getFilesInfo(ids: number[]): Observable<IFile[]>;
    abstract deleteFile(id: number): Observable<any>;
}
